export function stringTruncateFromCenter(
    str: string | undefined,
    maxLength: number
) {
    if (str === undefined) {
        return '-'
    }
    const midChar = '…'
    let left, right
    if (str.length <= maxLength) return str
    // eslint-disable-next-line prefer-const
    left = Math.ceil(maxLength / 2) +2
    // eslint-disable-next-line prefer-const
    right = str.length - Math.floor(maxLength / 2) + 1
    return str.substring(0, left) + midChar + str.substring(right)
}
